import { render, staticRenderFns } from "./AllOrderList.vue?vue&type=template&id=e384c2c8&scoped=true&"
import script from "./AllOrderList.vue?vue&type=script&lang=js&"
export * from "./AllOrderList.vue?vue&type=script&lang=js&"
import style0 from "./AllOrderList.vue?vue&type=style&index=0&id=e384c2c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e384c2c8",
  null
  
)

export default component.exports